import StepType from "./step.type";

export default class DeliveryStepModel extends StepType {}
